import { useI18n } from '../i18n';
import styles from './AuthContactSupport.module.css';

export type AuthContactPromptProps = {
  onContact: () => void;
};

/** Footer line: “Having trouble? Contact us” — opens the dedicated contact page. */
export function AuthContactPrompt({ onContact }: AuthContactPromptProps) {
  const { t } = useI18n();

  return (
    <p className={styles.promptRow}>
      {t('auth.portal.contactPrompt')}{' '}
      <button type="button" className={styles.promptButton} onClick={onContact}>
        {t('auth.portal.contactAction')}
      </button>
    </p>
  );
}
